export default {
  acab: 'ACAB',
  actions: 'Actions',
  addProduct: 'Add product',
  arcPosition: 'ARC position',
  businessId: 'Business id',
  businessPhone: 'Business phone',
  cancel: 'Cancel',
  client: 'Client',
  clientReference: 'Client reference',
  clients: 'Clients',
  clientSuccessfullyCreated: 'Client successfully created',
  clv: 'CLV',
  codeLab: 'Code Lab',
  colimptexCode: 'Colimptex code',
  color: 'Color',
  colors: 'Colors',
  colorSuccessfullyCreated: 'Color successfully created',
  colorSuccessfullyUpdated: 'Color successfully updated',
  composition: 'Composition',
  contactPerson: 'Contact',
  container: 'Container',
  containers: 'Containers',
  containerSuccessfullyCreated: 'Container successfully created',
  containerSuccessfullyUpdated: 'Container successfully updated',
  createClient: 'Create Client',
  createColor: 'Create Color',
  createContainerType: 'Create Container Type',
  createOrderDetail: 'Create Order Detail',
  createOrder: 'Create Order',
  createProduct: 'Create Product',
  createPurchase: 'Create purchase',
  createPurchaseDetail: 'Create purchase detail',
  createSeller: 'Create Seller',
  createSupplier: 'Create Supplier',
  created: 'created successfully',
  crf: 'CRF',
  csf: 'CSF',
  currency: 'Currency',
  deleteClient: 'Delete Client',
  deletePurchase: 'Delete Purchase',
  doYouWantToDeleteThisClient: 'Do you really want to delete this client?',
  doYouWantToDeleteThisColor: 'Do you really want to delete this color?',
  doYouWantToDeleteThisContainer: 'Do you really want to delete this container?',
  doYouWantToDeleteThisProduct: 'Do you really want to delete this product?',
  doYouWantToDeleteThisPurchase: 'Do you really want to delete this purchase?',
  doYouWantToDeleteThisSeller: 'Do you really want to delete this seller?',
  doYouWantToDeleteThisSupplier: 'Do you really want to delete this supplier?',
  editAddedProduct: 'Edit added product',
  editClient: 'Edit client',
  editColor: 'Edit color',
  editContainer: 'Edit container',
  editOrderDetail: 'Edit order detail',
  editOrder: 'Edit order',
  editProduct: 'Edit product',
  editProvider: 'Edit provider',
  editPurchase: 'Edit purchase',
  editSeller: 'Edit seller',
  editSupplier: 'Edit supplier',
  email: 'Email',
  enterDescription: 'Enter a description of the user',
  factory: 'Factory',
  fca: 'FCA',
  fiber: 'Fiber',
  finalKilogramsQuantity: 'Final quantity in kilograms',
  finalMetersQuantity: 'Final quantity in meters',
  finished: 'Finished',
  hs: 'HS',
  iva: 'IVA',
  key: 'key',
  kilogramsMaximumCapacity: 'Maximum capacity in kilograms',
  label: 'Label',
  language: 'Language',
  loading: 'Loading...',
  metersKilogramsQuantity: 'm/kg quantity',
  mt3: 'm3',
  mustChargeBeforeCreatingItems: 'Must charge before creating items',
  name: 'Name',
  newClient: 'New client',
  newColor: 'New color',
  newContainer: 'New container',
  newOrderDetail: 'New order detail',
  newOrder: 'New order',
  newProduct: 'New product',
  newProvider: 'New provider',
  newPurchase: 'New purchase',
  newSeller: 'New seller',
  newSupplier: 'New supplier',
  nit: 'Identification number',
  noElementsRegistered: 'No elements registered',
  onlyNumbersAllowed: 'Only numbers allowed',
  paint: 'Paint',
  performance: 'Performance',
  phone: 'Phone',
  portOccupation: 'Port Occupation',
  print: 'Printing',
  productionDate: 'Production date',
  product: 'Product',
  products: 'Products',
  productSuccessfullyCreated: 'Product successfully created',
  productSuccessfullyUpdated: 'Product successfully updated',
  profileImagePath: 'Profile image url',
  psv: 'PSV',
  purchaseSuccessfullyCreated: 'Purchase successfully created',
  purchaseSuccessfullyUpdated: 'Purchase successfully updated',
  pvp: 'PVP',
  referenceInChina: 'Reference in China',
  rgb: 'RGB',
  requiredAmount: 'Required amount',
  requirement: 'Requirement',
  save: 'Save',
  search: 'Search',
  seller: 'Seller',
  sellers: 'Sellers',
  sellerSuccessfullyCreated: 'Seller successfully created',
  sellerSuccessfullyUpdated: 'Seller successfully updated',
  shippingDate: 'Shipping date',
  shortName: 'Short name',
  sku: 'SKU',
  subInvoice: 'Sub invoice',
  sublimation: 'Sublimation',
  supplier: 'Supplier',
  suppliers: 'Suppliers',
  supplierSuccessfullyCreated: 'Supplier successfully created',
  supplierSuccessfullyUpdated: 'Supplier successfully updated',
  taxesRefund: 'Taxes refund',
  totalAmount: 'Total amount',
  trm: 'TRM',
  typeOfContainer: 'Type of container',
  updated: 'updated successfully',
  unitMeasure: 'Unit of measure',
  viewClient: 'View Client',
  weight: 'Weight',
  wide: 'Wide',
  withholdingTax: 'Withholding tax'
}
